import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import './QueryScreen.css';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import Paper from "@material-ui/core/Paper";
import DrillDownDataTable from './tables/DrillDownDataTable';
import Button from '@material-ui/core/Button';
import SaveAlt from '@material-ui/icons/SaveAlt';
import axiosInstance from '../common/AxiosInstace';
import EndpointsGetter from '../common/EndpointsGetter';
import omit from 'lodash/omit';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';
import { pageCount } from '@devexpress/dx-grid-core';
import ConfirmationDialog from '../common/ConfirmationDialog';

const styles = theme => ({
    layoutRoot: {},
    container: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        width: '100%'
    },
    root: {
        flexGrow: 1,
        height: 250
    },
    appBar: {
        position: 'relative'
    },
    title: {
        marginLeft: 30,
        flex: 1,
        fontSize: 20,
        color: '#fff'
    },
    exportIcon: {
        margin: '0 10px 4px 0'
    },
    circularProgress: {
        'position': 'absolute', 'z-index': '1', 'margin-left': 'auto', 'margin-right': 'auto',
        'top': '32%', 'left': '40%', 'display': 'flex', 'flex-direction': 'column', 'align-items': 'center'
    },
    progressText: {
        marginTop: 18,
        fontSize: 18
    }
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class DrillDownDataContainer extends PureComponent {
    state = {
        open: false,
        errorString: '',
        isLoading: false,
        showConfirmDialog: false
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.drillDownData !== this.props.drillDownData) && !isEmpty(this.props.drillDownData)) {
            this.setState({ open: true });
        }

        if (prevProps.isGridUpdating !== this.props.isGridUpdating) {
            this.setState({ isLoading: this.props.isGridUpdating });
        }
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    onExportClick = () => {
        const { totalElements } = this.props.athenaQuery;
        if (totalElements > 1000000) this.setState({ showConfirmDialog: true })
        else this.getExportedData();
    }

    getExportedData = () => {
        const accessToken = localStorage.getItem("access_token"),
            athenaQuery = { ...this.props.athenaQuery, limit: 1000000 };

        this.setState({ isLoading: true, errorString: '' });
        axiosInstance.post(`${EndpointsGetter.getDrillDownExportEndpoint()}`, omit(athenaQuery, ['offset', 'totalElements']), {
            headers: {
                'Authorization': 'Bearer ' + accessToken,
                'Content-type': 'application/json'
            }
        })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data])),
                    link = document.createElement('a');

                link.href = url;
                link.setAttribute('download', `${athenaQuery.dataGroup}-${moment(athenaQuery.tsStart).format('YYYY-MM-DD')}.csv`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                this.setState({ isLoading: false });
            })
            .catch(error => {
                console.log('error: ', error);
                this.getError(error);
            })
    }

    changeCurrentPage = (page) => {
        let { athenaQuery } = this.props,
            totalPages = pageCount(athenaQuery.totalElements, athenaQuery.limit);

        this.props.updateAthenaQuery({ "offset": page + 1 > totalPages ? totalPages - 1 : page });
    }

    changePageSize = (pageSize) => {
        this.props.updateAthenaQuery({
            "limit": pageSize
        })
    }

    getError(error) {
        let errorString = '';
        if (error) {
            if (error.code === 'ECONNABORTED') {
                errorString = "API Request timed out. Please try again after few seconds";
            } else if (error.response.status === 500) {
                errorString = "Operation was unsuccessful. Please try again after few seconds";
            } else if (error.response.status === 404) {
                errorString = "Error 404";
            } else if (error.response.status === 401) {
                // errorString = "Unauthorized";
            } else {
                errorString = error.response.data.message ? error.response.data.message : error.response.data.error_description;
                if (error.response.status === 400 && errorString.includes("Invalid refresh token")) {
                    this.props.history.push('/login');
                }
            }
        } else {
            errorString = "Something with the server went wrong. Please try again later."
        }

        this.setState({ isLoading: false, errorString: errorString });
    }

    handleConfirm = () => {
        this.setState({ showConfirmDialog: false }, () => {
            this.getExportedData();
        });
    }

    render() {
        const { open, isLoading, errorString, showConfirmDialog } = this.state,
            { classes, drillDownData, athenaQuery, isGridUpdating } = this.props;

        return (
            <Dialog
                fullScreen
                open={open}
                onClose={this.handleClose}
                TransitionComponent={Transition}
            >
                {isLoading ? (
                    <div className={classes.circularProgress}>
                        <CircularProgress color="secondary" />
                        <span style={isGridUpdating ? { opacity: 0 } : { opacity: 1 }} className={classes.progressText}>Fetching data. This might take some time...</span>
                    </div>
                ) : null}
                <div style={{ pointerEvents: isLoading ? 'none' : 'auto', 'filter': isLoading ? 'blur(3px)' : 'blur(0px)' }}>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <ArrowBack />
                            </IconButton>
                            <Typography className={classes.title}>
                                Data for period: {athenaQuery.tsStart ? athenaQuery.tsStart : ''} - {athenaQuery.tsEnd ? athenaQuery.tsEnd : ''}
                            </Typography>
                            <Button disabled={isLoading} onClick={this.onExportClick} size="medium" color="inherit">
                                <SaveAlt className={classes.exportIcon} />
                                Export
                        </Button>
                        </Toolbar>
                    </AppBar>
                    <div className='container-fluid'>
                        {errorString ?
                            <div className="screen-layout">
                                <label className="text-area-label col-lg-6"
                                    style={{ color: 'red' }}>{errorString}</label>
                            </div>
                            : null
                        }
                        <div className="p-24">
                            <Paper>
                                <DrillDownDataTable
                                    rows={drillDownData}
                                    changeCurrentPage={this.changeCurrentPage}
                                    changePageSize={this.changePageSize}
                                    athenaQuery={athenaQuery}
                                />
                            </Paper>
                        </div>
                    </div>
                </div>
                <ConfirmationDialog
                    open={showConfirmDialog}
                    message={'This is a test functionality, currently only up to 1,000,000 records can be exported. Do you wish to proceed?'}
                    handleConfirm={this.handleConfirm}
                    handleClose={() => this.setState({ showConfirmDialog: false })}
                />
            </Dialog>
        )
    }
}


DrillDownDataContainer.propTypes = {
    drillDownData: PropTypes.array,
    clearDrillDownData: PropTypes.func,
    athenaQuery: PropTypes.object,
    updateAthenaQuery: PropTypes.func,
    isGridUpdating: PropTypes.bool
};

export default withStyles(styles, { withTheme: true })(withRouter(DrillDownDataContainer));


// WEBPACK FOOTER //
// ./src/main/content/query/DrillDownDataContainer.js